import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';

// Layout
import Layout from './components/Layout/Layout';
import NotificationProvider from './components/Common/NotificationProvider';

// Auth
import Login from './pages/Auth/Login';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Unauthorized from './pages/Unauthorized';

// Dashboard
import Dashboard from './pages/Dashboard/Dashboard';

// Content Management
import ArticleList from './pages/Article/ArticleList';
import ArticleForm from './pages/Article/ArticleForm';
import CategoryList from './pages/Category/CategoryList';
import HeroContentList from './pages/HeroContent/HeroContentList';
import CarouselList from './pages/Carousel/CarouselList';

// Educational Content
import CourseList from './pages/Course/CourseList';
import CourseForm from './pages/Course/CourseForm';
import UniversityList from './pages/University/UniversityList';
import UniversityForm from './pages/University/UniversityForm';

// Communication
import ContactList from './pages/Contact/ContactList';
import CommentList from './pages/Comment/CommentList';

// Admin
import AdminDashboard from './pages/Admin/AdminDashboard';
import UserManagement from './pages/Admin/UserManagement';

// File Management
import UploadManager from './pages/Upload/UploadManager';
import DocumentList from './pages/Document/DocumentList';

// Reports
import Reports from './pages/Reports/Reports';

// Settings
import Settings from './pages/Settings/Settings';

// Advertisement
import AdvertisementList from './pages/Advertisement/AdvertisementList';
import AdvertisementForm from './pages/Advertisement/AdvertisementForm';
import AdStatsView from './pages/Advertisement/AdStatsView';

function App() {
  return (
    <Provider store={store}>
      <NotificationProvider>
        <Router>
          <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />

            {/* Content Management */}
            <Route path="articles" element={<ArticleList />} />
            <Route path="articles/new" element={<ArticleForm />} />
            <Route path="articles/edit/:id" element={<ArticleForm />} />
            <Route path="articles/view/:id" element={<ArticleForm />} />

            <Route path="categories" element={<CategoryList />} />

            <Route path="hero-content" element={<HeroContentList />} />

            <Route path="carousel" element={<CarouselList />} />

            {/* Educational Content */}
            <Route path="courses/new" element={<CourseForm />} />
            <Route path="courses/edit/:id" element={<CourseForm />} />
            <Route path="courses" element={<CourseList />} />
            <Route path="universities/new" element={<UniversityForm />} />
            <Route path="universities/edit/:id" element={<UniversityForm />} />
            <Route path="universities" element={<UniversityList />} />

            {/* Communication */}
            <Route path="contacts" element={<ContactList />} />
            <Route path="comments" element={<CommentList />} />

            {/* Admin - Only for ADMIN role */}
            <Route path="admin" element={
              <ProtectedRoute requiredRoles={['ADMIN', 'SUPER_ADMIN']}>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            <Route path="admin/users" element={
              <ProtectedRoute requiredRoles={['ADMIN', 'SUPER_ADMIN']}>
                <UserManagement />
              </ProtectedRoute>
            } />

            {/* File Management */}
            <Route path="uploads" element={<UploadManager />} />
            <Route path="documents" element={<DocumentList />} />

            {/* Reports */}
            <Route path="reports" element={<Reports />} />

            {/* Settings */}
            <Route path="settings" element={<Settings />} />

            {/* Advertisements */}
            <Route path="advertisements" element={<AdvertisementList />} />
            <Route path="advertisements/create" element={<AdvertisementForm />} />
            <Route path="advertisements/edit/:id" element={<AdvertisementForm />} />
            <Route path="advertisements/stats/:id" element={<AdStatsView />} />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </Router>
      </NotificationProvider>
    </Provider>
  );
}

export default App;
